<div mat-dialog-content>
    <h1>{{confirmation.message}}</h1>

</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{confirmation.firstButton}}</button>
    <button mat-button [mat-dialog-close]=true cdkFocusInitial>{{confirmation.secondButton}}</button>
</div>